<template>
  <CardAction
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderLargePrimary>
      <div :style="style.header">
        Bring your team on Zipteam.
      </div>
    </HeaderLargePrimary>
    <div :style="style.bottom">
      <ButtonPrimary @click="openModalToInviteUsers">
        Invite coworkers
      </ButtonPrimary>
    </div>
  </CardAction>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardAction from '@modules/v2/card/card-action'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import { Layout } from '@js/styles'
  import { mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'UserInvitation',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardAction,
      HeaderLargePrimary,
    },
    data: function () {
      return {
        style: {
          bottom: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
          },
          card: {
            minWidth: '140px',
            padding: Layout.space.md,
          },
          header: {
            lineHeight: 1.2,
            margin: `0 0 ${Layout.space.lg} 0`,
            overflowWrap: 'break-word',
          },
        },
      };
    },
    computed: {
      ...mapState({
        tenant: state => state.tenant,
      }),
    },
    methods: {
      openModalToInviteUsers: function () {
        const params = {
          tenant: this.tenant,
        };
        this.$modal.show(MODAL_WINDOW_NAMES.INVITE_TO_TENANT_PRIMARY, params);
      },
    },
  };
</script>
